import Header from '../../Components/Header/Header';
import React, { useEffect, useState } from 'react';
import './HoldAssignment.css';
import { putCall } from '../../Services/CommonService';
import { useNavigate, useParams } from 'react-router-dom';
import AssignmentDetailsHeader from '../common/AssignmentDetailsHeader';
import { getUserInfoFromSession } from '../../Services/session.mgmt';
import * as Constants from '../../constants/RepoReactConstants';
import { PINNCALE_LOG_OBJ } from '../../constants/commonJsonConstants';

import { CommonDataService, getcommentStr } from '../../Services/CommonDataService';

import { FcnaDB2Postcall } from '../../api/accountsummary.api';
import { AssignmentService } from '../../Services/AssignmentService';
import BuyerAssignmentInfo from '../../Components/BuyerAssignmentInfo';
import Button from '../../Components/Button/Button';
import { logPinnacleContact } from '../../Services/PinnacleService';

function HoldAssignment() {
  const navigate = useNavigate();
  let { teamWrkBpiNb } = useParams();
  console.log(teamWrkBpiNb);

  const [accountInformation, setAccountInformation] = useState([]);
  const [contractorInfoForComment, setContractorInfoForComment] = useState([]);

  const [assignmentDetails, setAssignmentDetails] = useState([]);
  const [buyerCoBuyerInfo, setBuyerCoBuyerInfo] = useState([]);
  const userInfo = getUserInfoFromSession();

  function getCurrentTimestamp() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // JavaScript months are 0-indexed
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }


  const onclickHandler = () => {
    Promise.all([

      logPinnacleContact(
        accountInformation,
        contractorInfoForComment,
        userInfo,
        Constants.ACTION_HOLD,
        Constants.rsHOLD_CONFIRM
      ),
      putCall(
        'processQuestion/updateCntrctAcct?bpiNb=' +
        teamWrkBpiNb +
        '&cntrctrNb=' +
        userInfo.cntrctrNb +
        '&sConfirm=Y&sCsrAction=H'
      ),
      FcnaDB2Postcall({
        acctNb: accountInformation?.custAcctNb,
        coBusCd: accountInformation?.coBusCd,
        transTypeCd: 21,
        sourceSystemCode: 12,
        lastUpdatedUserIdentificationCode: 'FCREPO',
        transactionDataText: teamWrkBpiNb + ';HOLD_CONFIRM',
        isImmediate: true,
      }),
    ])
      .then(([pinnResp, putResp, fcnadb2Resp]) => {
        console.log('Pinnacle Response:', JSON.stringify(pinnResp));
        console.log('putCall Response:', JSON.stringify(putResp));
        console.log('FcnaDB2Postcall Response:', JSON.stringify(fcnadb2Resp));
      })
      .catch((error) => {
        console.error('Error in Promise.all:', error);
      })
      .finally(() => {
        navigate('/outstandingAssignment');
      });
  };
  useEffect(() => {
    const fetchcommonInfo = async () => {
      try {
        const assignmentResponse = await AssignmentService.getAssignmentInfo(teamWrkBpiNb, userInfo.cntrctrNb);
        setAssignmentDetails(assignmentResponse.data);

        // Define multiple API calls
        const apiCall1 = CommonDataService.getAccountInfo(teamWrkBpiNb, userInfo.cntrctrNb);
        const apiCall2 = CommonDataService.getCntrctrInfoForComments(userInfo.userid);

        // Use Promise.all with await inside a try block
        const responses = await Promise.all([apiCall1, apiCall2]);

        setAccountInformation(responses[0]?.data);
        setContractorInfoForComment(responses[1]?.data);

        console.log('Data from API 1:', responses[0]?.data);
        console.log('Data from API 2:', responses[1]?.data);

        console.log(
          `getBuyerCobuyer Params coBusCd: ${responses[0]?.data?.coBusCd} ` +
          `disorigBranchCd: ${responses[0]?.data?.discorigBranchCd} ` +
          `custAcctNb: ${responses[0]?.data?.custAcctNb}`
        );

        AssignmentService.getBuyerCobuyerInfo(
          responses[0]?.data?.coBusCd,
          responses[0]?.data?.discorigBranchCd,
          responses[0]?.data?.custAcctNb
        )
          .then((buyerInfoResp) => {
            console.log('getBuyerCobuyer response:', buyerInfoResp);
            setBuyerCoBuyerInfo(buyerInfoResp?.data);
          })
          .catch((error) => {
            console.error('AssignmentService.getBuyerCobuyerInfo error:: ', error);
          });
      } catch (error) {
        // Handle any errors that occur in any of the promises
        console.error('An error occurred:', error);
      }
    };
    fetchcommonInfo();
  }, [teamWrkBpiNb, userInfo.cntrctrNb, userInfo.userid]);

  return (
    <>
      <Header heading="Hold Assignment" />
      <br />
      <AssignmentDetailsHeader bpiNo={teamWrkBpiNb} />
      <br />
      <div>
        <BuyerAssignmentInfo buyerCoBuyerInfo={buyerCoBuyerInfo} assignmentDetails={assignmentDetails} />
        <br />
        <section>
          <div className="center">
            <Button label="Acknowledge" onClick={onclickHandler} />
          </div>
        </section>
      </div>
    </>
  );
}

export default HoldAssignment;
